import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Navbar } from '../../components/common/Navbar';
import { Footer } from '../../components/common/Footer';
import { Badge } from '../../components/common/Badge';
import { NEWS_DATA } from '../../data/siteData';
import { SEO } from '../../components/common/SEO';

export default function NewsIndexPage() {
  const [selectedCat, setSelectedCat] = useState<string>('すべて');
  const categories = ['すべて', '企業情報', '製品・サービス', '開発・協業', '展示会・登壇'];

  const filtered =
    selectedCat === 'すべて'
      ? NEWS_DATA
      : NEWS_DATA.filter((n) => n.category === selectedCat);

  return (
    <div className="min-h-screen flex flex-col bg-white text-navy">
      <SEO
        title="お知らせ｜企業情報・製品アップデート"
        description="Spaq株式会社の企業情報、プロダクト（「1minute solar」「SPAQ CORE」）のアップデート、協業・イベント情報をお知らせします。"
        canonicalPath="/news"
      />
      <Navbar />

      <main className="flex-1">
        <section className="bg-hero-gradient border-b border-surface-border py-14 md:py-20">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
            <Badge variant="cyan" className="mb-4">NEWS & ANNOUNCEMENTS</Badge>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy tracking-tight">
              お知らせ
            </h1>
            <p className="mt-4 text-base sm:text-lg text-navy-muted max-w-2xl">
              Spaq株式会社の企業情報、プロダクト（「1minute solar」「SPAQ CORE」）のアップデート、協業・イベント情報をお知らせします。
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setSelectedCat(cat)}
                  className={`px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition-all ${
                    selectedCat === cat
                      ? 'bg-navy text-white'
                      : 'bg-surface-slate text-navy-muted hover:text-navy border border-surface-border'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="divide-y divide-surface-border border-y border-surface-border">
              {filtered.map((news) => (
                <Link
                  key={news.slug}
                  to={`/news/${news.slug}`}
                  className="py-6 flex flex-col gap-2 group hover:bg-surface-slate/60 px-4 -mx-4 rounded-2xl transition-colors"
                >
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="text-xs font-mono text-navy-muted">{news.date}</span>
                    <Badge
                      variant={
                        news.category === '製品・サービス'
                          ? 'cyan'
                          : news.category === '開発・協業'
                          ? 'gold'
                          : 'slate'
                      }
                      size="sm"
                    >
                      {news.category}
                    </Badge>
                    {news.isPastEvent && (
                      <Badge variant="slate" size="sm">開催終了イベント</Badge>
                    )}
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base sm:text-lg font-bold text-navy group-hover:text-spaq-cyan-dark transition-colors">
                      {news.title}
                    </h2>
                    <ChevronRight className="w-5 h-5 text-navy-muted group-hover:text-spaq-cyan-dark shrink-0" />
                  </div>
                  <p className="text-xs sm:text-sm text-navy-muted leading-relaxed">
                    {news.summary}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
